import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
// import { useDispatch } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import { toast } from "react-toastify";
import FormFields from "./FormFields";
import { useDispatch } from "react-redux";
import {
  getRegionById,
  updateRegion,
} from "../../../redux/slices/regions/regionsThunk";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";
import { useSelector } from "react-redux";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const EditRegionPage = () => {
  const regions_data = useSelector((state) => state.regions.region);
  const regions_loading = useSelector((state) => state.regions.loading);
  const [form] = Form.useForm();
  // const dispatch = useDispatch();
  const history = useHistory();
  const dispatch = useDispatch();

  const pathname = history.location.pathname; // e.g., "/edit/région/123"
  const parts = pathname.split("/");
  const region_id = parts[parts.length - 1]; // "123"

  useEffect(() => {
    dispatch(getRegionById(region_id));
    dispatch(getGovernments({page:1 , limit: 10}));
  }, [dispatch, region_id]);

  const onFinish = (values) => {
    const formattedValues = {
      name: values.name,
      abreviation: values.abreviation,
    };

    console.log("values", formattedValues);

    // dispatch(addDoctor(formattedValues));
    toast.success("Region added successfully!");
  };
  

  const editRegion = () => {
    
    const region_data = {
      name: form.getFieldValue("name"), // Assuming the name field is "region"
      government: form.getFieldValue("id"), // Assuming the government field is "government"
    };
    if (region_id) {
      dispatch(updateRegion({ regionId: region_id, regionData: region_data }));
    } else {
      console.error("Region ID is undefined");
    }
  };

  const onReset = () => {
    form.resetFields();
  };

  const navigateTo = (path) => {
    history.push(path);
  };
  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Modifier une région"
      />
      <Card bordered={false}>
        <Form {...layout} form={form} name="control-hooks" onFinish={onFinish}>
          {!regions_loading && <FormFields data={regions_data} />}
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit" onClick={editRegion}>
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
              <Button
                type="link"
                htmlType="button"
                onClick={() => navigateTo("/régions")}
              >
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default EditRegionPage;
